import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import { AccountCircle } from "@mui/icons-material";
import Logout from "@mui/icons-material/Logout";
import { useAuth } from "../../../hooks/useAuth";
import logoSrc from "./brandLogo.svg";

interface IBrandHeaderProps {
  user?: any;
  pharmacy?: any;
}

export const BrandHeader: React.FunctionComponent<IBrandHeaderProps> = ({
  user,
  pharmacy,
}) => {
  const { signOut } = useAuth();
  const accountName = !pharmacy ? `${user?.firstName} ${user?.lastName}` : pharmacy.legalName;

  return (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        borderBottom: "1px solid #E2E8F0",
        color: "#1E293B",
        paddingX: { xs: 3, md: 4 },
        paddingY: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: user ? "space-between" : "flex-start",
        fontFamily: '"Source Sans 3", sans-serif',
      }}
    >
      <Link href="https://www.primepostrx.com" sx={{ display: "flex", height: "34px" }}>
        <img src={logoSrc} alt="PrimePostRx" height={34} />
      </Link>
      {user && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", mr: 2, ml: 3 }}>
            <AccountCircle />
            <Box sx={{ ml: 1, fontSize: 14 }}>{accountName}</Box>
          </Box>
          <IconButton
            color="inherit"
            onClick={async () => {
              await signOut();
            }}
          >
            <Logout />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default BrandHeader;
